<template>
	<transition name="fade">
		<div
			:class="{ 'acca-on-mini-betslip': 1 }"
			v-if="validNoOfBets < env.accaBonusMinSelections && show"
		>
			<p class="acca-on-mini-betslip__desc">
				{{
					$t("betslip.bonus-description-mini", {
						accaBonusMinSelectionsValidNoOfBets:
							env.accaBonusMinSelections - validNoOfBets,
						accaBonusMinSelectionsValidNoOfBetsWithS:
							env.accaBonusMinSelections - validNoOfBets > 1 ? `s` : ``,
						accaBonusMinimumOdd: env.accaBonusMinimumOdd,
						accaBonusMatrixAccaBonusMinSelections:
							env.accaBonusMatrix[env.accaBonusMinSelections],
						accaBonusProductName: env.accaBonusProductName,
					})
				}}
			</p>
		</div>
		<div
			class="acca-on-mini-betslip acca-on-mini-betslip--active"
			v-if="validNoOfBets >= env.accaBonusMinSelections && show"
		>
			<p class="acca-on-mini-betslip__desc" v-if="percentage < max">
				{{ bonus | currency }} ({{ percentage }}%)
				{{ $t("betslip.bonus-activated") }} 🎉
				<br />
				{{
					$t("betslip.add-more-bets", {
						nextLevelNextValidNoOfBets: nextLevel.next - validNoOfBets,
						nextLevelNextValidNoOfBetsWithS:
							nextLevel.next - validNoOfBets > 1 ? `s` : ``,
						accaBonusMinimumOdd: env.accaBonusMinimumOdd,
						nextLevelPerc: nextLevel.perc,
						accaBonusProductName: env.accaBonusProductName,
					})
				}}
			</p>
			<p class="acca-on-mini-betslip__desc" v-else>
				{{
					$t("betslip.reached-max-bonus", {
						accaBonusProductName: env.accaBonusProductName,
						max: max,
					})
				}}% 🎉
			</p>
		</div>
	</transition>
</template>

<script>
import ProgressBar from "./ProgressBar.vue";
import { isNull } from "lodash";
export default {
	components: { ProgressBar },
	data() {
		return {
			show: false,
			currentTimeout: null,
		};
	},
	watch: {
		"$store.getters.betSlipCount"(n, o) {
			let vm = this;
			if (n > o) {
				clearTimeout(vm.currentTimeout);
				vm.show = true;
				vm.currentTimeout = setTimeout(() => {
					vm.show = false;
				}, 5000);
			}
		},
	},
	computed: {
		bets() {
			return this.$store.getters.betSlip;
		},
		percentage() {
			if (!this.validNoOfBets) return 0;
			if (!this.env.accaBonusMatrix.hasOwnProperty(this.validNoOfBets))
				return this.env.accaBonusMatrix[
					Object.keys(this.env.accaBonusMatrix).length
				];

			return this.env.accaBonusMatrix[this.validNoOfBets];
		},
		max() {
			const max = this.env.accaBonusMatrix[
				Object.keys(this.env.accaBonusMatrix).length
			];
			return max;
		},
		validNoOfBets() {
			return this.bets.filter(
				(bet) => Number(bet.odd_value) >= this.env.accaBonusMinimumOdd
			).length;
		},
		nextLevel() {
			let next =
				this.validNoOfBets < this.env.accaBonusMinSelections
					? this.env.accaBonusMinSelections
					: this.validNoOfBets + 1;

			return { next, perc: this.env.accaBonusMatrix[next] };
		},
		bonus() {
			return this.possibleWin * (this.percentage * 0.01) > this.env.maxAccaBonus
				? this.env.maxAccaBonus
				: Math.trunc(this.possibleWin * this.percentage) / 100 || 0;
		},
		stake() {
			let vm = this;
			if (isNull(vm.$store.getters.stake)) {
				vm.$store.commit("updateStake", parseFloat(vm.env.minimumBetAmount));
				return vm.env.minimumBetAmount;
			} else {
				return vm.$store.getters.stake;
			}
		},
		possibleWin() {
			let possibleWin = this.totalOdds * this.stake;
			return possibleWin > this.env.maximumPossibleWin
				? this.env.maximumPossibleWin
				: possibleWin;
		},
		totalOdds() {
			let oddValues = this.$store.getters.betSlip.map((bet) => {
				return Number(bet.odd.odd_value);
			});

			return Math.trunc(oddValues.reduce((a, b) => a * b, 1) * 100) / 100;
		},
	},
};
</script>

<style lang="scss">
.acca-on-mini-betslip {
	background: var(--yellow);
	padding: 10px;
	border-radius: 8px;
	position: fixed;
	bottom: calc(38px + var(--margin-bottom));
	right: 5px;
	z-index: 9999;
	color: var(--always-black);
	&--active {
		background: var(--green);
		color: var(--always-white);
	}
	&__desc {
		margin: 0;
		font-size: var(--font-smallest);
	}
	&__progress-bar {
		margin-bottom: 5px;
	}

	.fade-enter-active,
	.fade-leave-active {
		-webkit-animation: fadein 0.5s;
		animation: fadein 0.5s;
	}

	.fade-enter,
	.fade-leave-to {
		-webkit-animation: fadeout 0.5s 5s;
		animation: fadeout 0.5s 5s;
	}

	/* Animations to fade the snackbar in and out */
	@-webkit-keyframes fadein {
		from {
			bottom: 0;
			opacity: 0;
		}
		to {
			bottom: 5px;
			opacity: 1;
		}
	}

	@keyframes fadein {
		from {
			bottom: 0;
			opacity: 0;
		}
		to {
			bottom: 5px;
			opacity: 1;
		}
	}

	@-webkit-keyframes fadeout {
		from {
			bottom: 5px;
			opacity: 1;
		}
		to {
			bottom: 0;
			opacity: 0;
		}
	}

	@keyframes fadeout {
		from {
			bottom: 5px;
			opacity: 1;
		}
		to {
			bottom: 0;
			opacity: 0;
		}
	}
}
</style>
